import { render, staticRenderFns } from "./TableProductEceran.vue?vue&type=template&id=03612dc4"
import script from "./TableProductEceran.vue?vue&type=script&lang=js"
export * from "./TableProductEceran.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports